import isMobile from 'ismobilejs';
import gsap from 'gsap';

export default function SizeSVG(element) {
  if (element) {
    if (element.getAttribute('width')) {
      const svgWidth = parseFloat(element.getAttribute('width').replace('px', ''));

      if (!window.is_mobile && (window.innerWidth < 1440 && window.innerWidth > 1025)) {
        gsap.set(element, {
          //width: ,
          width: `max(${svgWidth-2}px, min(${(svgWidth * 100) / 1920 + 'vw'}, ${svgWidth}px))`,
          height: 'auto',
          maxWidth: element.getAttribute('width') + 'px'
        });
      }
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const svgs = document.querySelectorAll('svg:not(.no--resize), .svg:not(.no--resize) img');
  [...svgs].map(svg => SizeSVG(svg));
});

window.addEventListener('resize', () => {
  window.is_mobile = isMobile().phone || window.innerWidth <= 1024;

  if (window.is_mobile) {
    const svgs = document.querySelectorAll('svg:not(.no--resize), .svg:not(.no--resize) img');
    [...svgs].map(svg => svg.removeAttribute('style'));
  }
});
